/**
 * Grow a control's pressable area to 44px without drawing it bigger (X-7 of the
 * 2026-10-15 web design review: "keep each glyph's size and grow the hit area").
 *
 * The control becomes `relative` and gets an invisible `::before` pulled out of
 * its box, so a 36px button answers a press over 44px and nothing on the page
 * moves. A `::before` belongs to the control, so a press on it is a press on
 * the control, and `:active` and `:focus-visible` on the control apply as
 * before. Each shape below was measured in a browser (a scan of
 * `elementFromPoint` across the control), and each exists for a reason that only
 * a real layout shows:
 *
 * - **`inset` is measured from the padding box.** A control with a 1px border
 *   (the send buttons) needs 5px to reach 4px past its drawn edge; 4px gave 42.
 * - **A pseudo-element with only `top` and `bottom` set is 0px wide.** A control
 *   that grows taller only needs `inset-x-0` as well.
 * - **An ancestor with `overflow: hidden` clips what a pseudo-element grows
 *   into.** The coach page's header ends where its container does, so the X at
 *   the right edge grows up, down and left, never right.
 *
 * Whole class names, never built from parts: Tailwind finds a class by
 * scanning for the whole string.
 */
/** A 36px control with a 1px border: 44px in both directions. */
export const HIT_AREA_FROM_36_BORDERED = "relative before:absolute before:-inset-[5px] before:content-['']";
/** A 36px-tall control that is wider than 44px already: 44px tall, as wide as it is. */
export const HIT_AREA_TALLER = "relative before:absolute before:inset-x-0 before:-inset-y-1 before:content-['']";
/** A 36px control at the right edge of a clipping container: 44px by growing up, down and left. */
export const HIT_AREA_FROM_36_LEFTWARD = "relative before:absolute before:-inset-y-1 before:-left-2 before:right-0 before:content-['']";
